export default __webpack_public_path__ + "static/media/icon-unionpay.277ec77b7b3484bd18fcbdbd6473c603.svg";